import { Link } from "react-router-dom";
import { BookOpen, PlayCircle, Layers } from "lucide-react";

export function CourseCard({ course }) {
  return (
    <Link
      to={`/courses/${course.id}`}
      data-testid={`course-card-${course.id}`}
      className="group flex flex-col rounded-2xl bg-white border border-slate-200 overflow-hidden hover:-translate-y-1 hover:shadow-xl hover:border-teal-500/40 transition-[transform,box-shadow,border-color] duration-300"
    >
      <div className="relative h-44 overflow-hidden bg-slate-100">
        <img
          src={course.cover_image || "https://images.unsplash.com/photo-1758685848561-3658f433e6a0?w=800&q=80"}
          alt={course.title}
          className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          {course.is_free ? (
            <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-500 text-white shadow">FREE</span>
          ) : (
            <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-amber-500 text-white shadow">₹{course.price}</span>
          )}
        </div>
        <div className="absolute top-3 right-3">
          <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-white/90 text-slate-700 backdrop-blur">{course.level}</span>
        </div>
      </div>

      <div className="flex flex-col flex-1 p-5">
        <span className="text-xs font-semibold uppercase tracking-widest text-teal-700 mb-2">{course.category}</span>
        <h3 className="text-lg font-semibold text-slate-900 leading-snug mb-1.5" style={{ fontFamily: "Outfit, sans-serif" }}>
          {course.title}
        </h3>
        <p className="text-sm text-slate-500 line-clamp-2 flex-1">{course.description}</p>
        <div className="flex items-center gap-4 mt-4 pt-4 border-t border-slate-100 text-xs text-slate-500">
          <span className="flex items-center gap-1"><Layers className="h-3.5 w-3.5" /> {course.module_count} modules</span>
          <span className="flex items-center gap-1"><PlayCircle className="h-3.5 w-3.5" /> {course.lesson_count} lessons</span>
          <span className="ml-auto text-teal-700 font-semibold flex items-center gap-1">View <BookOpen className="h-3.5 w-3.5" /></span>
        </div>
      </div>
    </Link>
  );
}
